<div fxLayout="row" fxLayoutAlign="center center" fxFlex="1 1 100%" fxFlex.gt-sm="1 1 85%" fxFlex.gt-md="1 1 70%">
  <button (click)="delete.emit()" fxFlex="nogrow" mat-flat-button color="warn"
          [matTooltip]="withMediegoTooltip ? ('COMMON.ADMINISTRATION.WARNING_MESSAGE' | translate) : ''">
    <mat-icon>warning_amber</mat-icon> {{ deleteText | translate }}
  </button>
</div>
